<!--
  ATTENTION : ce <template> est une COPIE du template généré FicheSalarieAbstract.vue,
  nécessaire pour ajouter le bloc "Contrats" (aucun slot libre n'existe dans le généré).
  Si FicheSalarieAbstract.vue est régénéré avec des changements de structure, re-synchroniser
  cette copie manuellement. Le seul ajout par rapport au généré est le bloc
  SALARIE_CONTRAT_ABSTRACT inséré après le bloc RIB.
-->
<template>
      <fiche-header
:ressource="ressource"
                    @back="back"
                    @open-all="openAll"
                    @close-all="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-row class="ma-0">
    <div v-if="hasItems" class="col-5">
    <v-col v-if="isDisplayed('SALARIE_IDENTITE_ABSTRACT')" class="section_salarie_identite_abstract">
      <div>
        <slot name="section-salarie-identite-abstract">
          <section-salarie-identite-abstract
id="SALARIE_IDENTITE_ABSTRACT"
                                             ref="SALARIE_IDENTITE_ABSTRACT"
                                             :extended="isExtended('SALARIE_IDENTITE_ABSTRACT')"
                                             :show-button="true"
                                             :auto-save="true"
                                             :read-only="readOnly"
                                             :module-id="moduleId"
                                             :search-text="searchText"
                                             :ressource-header="ressource"
                                             :fiche="fiche"
                                             :salarie=selectedSalarie
                                             :route="route"
                                             :attribut="attribut"
                                             @extended="setExtended"
                                             @fullscreen="setFullscreen"
                                             @status="updateStatus"
                                             @open-section="openSection"
                                             @updated="salarieUpdated"
                                             @select-item = "selectItem">
          </section-salarie-identite-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('SALARIE_COORDONNEES_ABSTRACT')" class="section_salarie_coordonnees_abstract">
      <div>
        <slot name="section-salarie-coordonnees-abstract">
          <section-salarie-coordonnees-abstract
id="SALARIE_COORDONNEES_ABSTRACT"
                                                ref="SALARIE_COORDONNEES_ABSTRACT"
                                                :extended="isExtended('SALARIE_COORDONNEES_ABSTRACT')"
                                                :show-button="true"
                                                :auto-save="true"
                                                :read-only="readOnly"
                                                :module-id="moduleId"
                                                :search-text="searchText"
                                                :ressource-header="ressource"
                                                :fiche="fiche"
                                                :salarie=selectedSalarie
                                                :adresse=selectedAdresse
                                                :route="route"
                                                :attribut="attribut"
                                                @extended="setExtended"
                                                @fullscreen="setFullscreen"
                                                @status="updateStatus"
                                                @open-section="openSection"
                                                @updated="salarieUpdated"
                                                @select-item = "selectItem">
          </section-salarie-coordonnees-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT')" class="section_salarie_info_complementaires_abstract">
      <div>
        <slot name="section-salarie-info-complementaires-abstract">
          <section-salarie-info-complementaires-abstract
id="SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT"
                                                         ref="SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT"
                                                         :extended="isExtended('SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT')"
                                                         :show-button="true"
                                                         :auto-save="true"
                                                         :read-only="readOnly"
                                                         :module-id="moduleId"
                                                         :search-text="searchText"
                                                         :ressource-header="ressource"
                                                         :fiche="fiche"
                                                         :salarie=selectedSalarie
                                                         :route="route"
                                                         :attribut="attribut"
                                                         @extended="setExtended"
                                                         @fullscreen="setFullscreen"
                                                         @status="updateStatus"
                                                         @open-section="openSection"
                                                         @updated="salarieUpdated"
                                                         @select-item = "selectItem">
          </section-salarie-info-complementaires-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('SALARIE_ETAT_CIVIL_ABSTRACT')" class="section_salarie_etat_civil_abstract">
      <div>
        <slot name="section-salarie-etat-civil-abstract">
          <section-salarie-etat-civil-abstract
id="SALARIE_ETAT_CIVIL_ABSTRACT"
                                               ref="SALARIE_ETAT_CIVIL_ABSTRACT"
                                               :extended="isExtended('SALARIE_ETAT_CIVIL_ABSTRACT')"
                                               :show-button="true"
                                               :auto-save="true"
                                               :read-only="readOnly"
                                               :module-id="moduleId"
                                               :search-text="searchText"
                                               :ressource-header="ressource"
                                               :fiche="fiche"
                                               :salarie=selectedSalarie
                                               :route="route"
                                               :attribut="attribut"
                                               @extended="setExtended"
                                               @fullscreen="setFullscreen"
                                               @status="updateStatus"
                                               @open-section="openSection"
                                               @updated="salarieUpdated"
                                               @select-item = "selectItem">
          </section-salarie-etat-civil-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('SALARIE_RIB_ABSTRACT')" class="section_salarie_rib_abstract">
      <div>
        <slot name="section-salarie-rib-abstract">
          <section-salarie-rib-abstract
id="SALARIE_RIB_ABSTRACT"
                                        ref="SALARIE_RIB_ABSTRACT"
                                        :extended="isExtended('SALARIE_RIB_ABSTRACT')"
                                        :show-button="true"
                                        :auto-save="true"
                                        :read-only="readOnly"
                                        :module-id="moduleId"
                                        :search-text="searchText"
                                        :ressource-header="ressource"
                                        :fiche="fiche"
                                        :rib=selectedRib
                                        :salarie=selectedSalarie
                                        :route="route"
                                        :attribut="attribut"
                                        @extended="setExtended"
                                        @fullscreen="setFullscreen"
                                        @status="updateStatus"
                                        @open-section="openSection"
                                        @updated="salarieUpdated"
                                        @select-item = "selectItem">
          </section-salarie-rib-abstract>
        </slot>
      </div>
    </v-col>
    <!-- Ajout custom : bloc Contrats (compteur + ouverture de la liste des contrats du salarié) -->
    <v-col v-if="isDisplayed('SALARIE_CONTRAT_ABSTRACT')" class="section_salarie_contrat_abstract">
      <div>
        <slot name="section-salarie-contrat-abstract">
          <section-salarie-contrat-abstract
id="SALARIE_CONTRAT_ABSTRACT"
                                            ref="SALARIE_CONTRAT_ABSTRACT"
                                            :read-only="readOnly"
                                            :module-id="moduleId"
                                            :fiche="fiche"
                                            :salarie=selectedSalarie
                                            :route="route"
                                            :attribut="attribut"
                                            @open-section="openSection">
          </section-salarie-contrat-abstract>
        </slot>
      </div>
    </v-col>
  </div>
      <v-col v-if="!hasItems" cols="6" class="empty-list-container">
        <img src="@/assets/SVG/empty-list.svg" class="empty-list-logo"/>
        <div class="empty-list-label">{{ getNewLabel() }}</div>
        <div v-if="canAdd" class="pt-3">
          <v-btn
class="base"
                 :outlined="true"
                 :loading="false"
                 :block="true"
                 variant="flat"
                 @click="addItem">
            {{ addLabel }}
          </v-btn>
        </div>
      </v-col>
  </v-row>
  <Transition name="scrim">
    <div v-if="sectionOpen" class="global-scrim" @click="sectionOpen = false"></div>
  </Transition>

  <Transition name="slide-panel">
    <div v-if="sectionOpen" class="local-panel-wrap">
      <div class="local-panel col-5">
        <component :is="sectionComponent" ref="SECTION_DIALOG" v-bind="currentProperties" v-on="events"></component>
      </div>
    </div>
  </Transition>
  </div>
</template>

<script lang="ts">
  import { defineAsyncComponent, defineComponent, markRaw } from "vue";
  import FicheSalarieAbstract from '@/generated/fiches/FicheSalarieAbstract.vue';
  import SectionSalarieContratAbstract from '@/custom/sections/SectionSalarieContratAbstract.vue';
  import {Extended} from "@/framework/base/classes/Schema.ts";  
  import Adresse from "@/extend/classes/Adresse.ts";
  import {storeAdresse, storeSalarie, storeSession} from "@/generated/stores";
  import UserProfile, {EnumProfile} from "@/framework/base/classes/UserProfile.ts";
  import Owner from "@/extend/classes/Owner.ts";
  import {ObjTypes} from "@/generated/classes/ObjTypes.ts";
  import {Fiches, Modules, Sections} from "@/generated/classes/AppSchema.ts";
  import {FwkButtons, RessourceFwkButton} from "@/ressources/globalRessources.ts";
  import Route from "@/extend/classes/Route.ts";
  import Section from "@/framework/base/classes/Section.ts";
  import {getSection} from "@/framework/base/helpers/ComponentFinder.ts";
  import {goToModule} from "@/framework/base/helpers/NavHelper.ts";
  import {takePendingReopenSalarieContrats} from "@/custom/helpers/salarieContratReturn.ts";
  import Salarie from "@/extend/classes/Salarie.ts";
  import Rib from '@/extend/classes/Rib';
  import { storeRib } from '@/generated/stores';

  
  export default defineComponent({
    components: { SectionSalarieContratAbstract },
    extends: FicheSalarieAbstract,
    data() {
      return {
        adresse: new Adresse(),
      }
    },
    computed: {
      selectedAdresse (): Adresse {
        if (this.adresse.id < 0) {
          storeAdresse.mAdresseDeleted(this.adresse.id);
        }
        this.updateAdresseOwner();
        return this.adresse;
      },
      selectedRib(): Rib {
        let rib = new Rib();
        if (this.salarie.ribId == 0) {
        rib = storeRib.createNewRib();
      } else {
        rib = storeRib.getRib(this.salarie.ribId);
      }
      const owner = new Owner();
      owner.objType = ObjTypes.SALARIE;
      owner.objId = this.salarie.id;
      rib.owner = owner;
      return rib;
      },
       isSalarie (): boolean {
        let res = false;
        const user = storeSession.connectedUser;
        if (user) {
          res = UserProfile.hasProfile(user, EnumProfile.salarie);
        }
        return res;
      },
      canAdd() : boolean {
        return this.salarie.id < 0;
      },
      addLabel(): string {
        return RessourceFwkButton(FwkButtons.NEW_SALARIE).label;
      },
      selectedSalarie (): Salarie {
        if (this.salarie.id > 0) {
          return storeSalarie.getSalarie(this.salarie.id);
        } else {
          return this.salarie
        }
      },    
    },
    methods: {
      getNewLabel() : string {
        return "Création d'un salarié";
      },
      addItem() : void {
        const route = new Route();
        const section = new Section();
        const loader = getSection("SectionSalarieExtend");
        let component = null;
        if (loader) {
          component = markRaw(defineAsyncComponent(loader as any));
        }
        this.sectionComponent = component;
        section.component = component;
      },
      updateAdresseOwner () {
        if (this.salarie.adresseId == 0) {
          this.adresse = storeAdresse.createNewAdresse();
        } else {
          this.adresse = storeAdresse.getAdresse(this.salarie.adresseId);
        }
        this.adresse.owner = new Owner()
        this.adresse.owner.objType = ObjTypes.CONTACT;
        this.adresse.owner.objId = this.salarie.id;
      },
      isDisplayed (value: string): boolean {
        if (this.salarie.id <= 0) {
          return false;
        }
        if ((!this.salarie || this.salarie.id < 0) && value == 'SALARIE_IDENTITE_ABSTRACT') {
          this.setExtended(new Extended('SALARIE_IDENTITE_ABSTRACT', this.fiche, true));
        }
        // Bloc Contrats : réservé à l'employeur / au gestionnaire interne.
        // Un salarié consulte ses contrats depuis son propre menu.
        if (value == 'SALARIE_CONTRAT_ABSTRACT') {
          return !this.isSalarie;
        }
        return true;
      },
      // Si on revient du détail d'un contrat ouvert depuis la liste des contrats du salarié, la
      // fiche Salarié a servi à reconstruire la pile d'historique du module : on rouvre aussitôt
      // la liste par-dessus (pile [SALARIE_ABSTRACT, CONTAINER]) pour que son "Retour" revienne
      // nativement ici. Sinon comportement normal de la fiche.
      ficheMounted () {
        const reopen = takePendingReopenSalarieContrats();
        if (reopen) {
          goToModule(this.router, reopen);
          return;
        }
        this.onShowSectionChanged();
        this.setFocus();
      }
    }
})
</script>
